// extracted by mini-css-extract-plugin
export default {"parameter":"TextInput_parameter__2vVk8","parameterTitle":"TextInput_parameterTitle__o7c57"};